<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 系统管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="100px">
          <el-row>
            <el-col :span="5">
              <el-form-item label="出库单号" prop="outbillCode">
                <el-input v-model.number="searchform.outbillCode" placeholder="出库单号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="经销商编码" prop="dealerCode">
                <el-input v-model.number="searchform.dealerCode" placeholder="经销商编码" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="码" prop="qrcode">
                <el-input v-model.number="searchform.qrcode" placeholder="请输入码" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"  >查询
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{ $route.meta.title }}</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <el-table-column prop="outBillCode" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freightBillCode" label="运单号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="productCode" label="产品编码" min-width="120" show-overflow-tooltip />
            <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip />
            <el-table-column prop="qrcode" label="异常码" min-width="120" show-overflow-tooltip />
            <el-table-column prop="createTime" label="创建时间" min-width="120" show-overflow-tooltip />
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { signqrcodescanloglist } from "@/api/physical";
import axios from "axios";
export default {

  mounted() {
    this.listLoading = true;
    this.search();
    console.log(this.$route)
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      tableData: [],
      codeVisible: false,
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      searchform: {
        "cityName": "",
        "dealerCode": "",
        "enterpriseCode": "",
        "freightBillCode": "",
        "limit": 10,
        "outbillCode": "",
        "page": 1,
        "pdfUrl": "",
        "productCode": "",
        "provinceName": "",
        "qrcode": "",
        "signCity": "",
        "signCountry": "",
        "signDistrict": "",
        "signProvince": "",
      },
      value: true,
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      signqrcodescanloglist(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData);
        this.total_count = response.data.totalCount;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        //obj[i].operTime = this.$parseTime(obj[i].operTime);  
      }
    },
    //搜索事件
    search() {
      // this.currentPage = 1;
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //分页跳转事件
    currentchange(page) {
      this.searchform.page = page;
      this.search();
      console.log(page);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.limit = pageSize;
      this.search();
    }
  }
};
</script>
<style scoped>
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}
</style>